import { observable, action, reaction } from 'mobx';

class NavigationStore {
  @observable isMobileNavOpen = false;

  @observable buttonsSectionWidth = 0;

  openMobileNav() {
    this.isMobileNavOpen = true;
  }

  closeMobileNav() {
    this.isMobileNavOpen = false;
  }

  @action
  setButtonsSectionWidth(buttonsSectionWidth) {
    this.buttonsSectionWidth = buttonsSectionWidth;
  }

  reactToMobileNavChange(callback) {
    return reaction(
      () => this.isMobileNavOpen,
      (data, theReaction) => callback(data, theReaction),
    );
  }
}

export default NavigationStore;



// WEBPACK FOOTER //
// ./src/stores/Navigation.store.js